import { create } from 'zustand';

type StateFromFunctions<T extends unknown[]> = T extends [infer F, ...infer R]
  ? F extends (...args: unknown[]) => object
    ? StateFromFunctions<R> & ReturnType<F>
    : unknown
  : unknown;

/**
 * Set store slices types
 * export type AppState = StateFromFunctions<[typeof createLoginSlice]>;
 */
export type AppState = StateFromFunctions<unknown[]>;

export const useStore = create<AppState>(() => ({}));
